import { TXGUISection } from "../../interfaces/gui/fields.interfaces";

export const X_ARTICLE_GUI_FIELDS: TXGUISection = {
  Image: [
    {
      label: "Transition",
      name: "imageTransition",
      type: "toggle_option",
      options: [
        { value: "none", label: "Aucune" },
        { value: "fade", label: "Fondu" },
        { value: "zoom_out", label: "Zoom" },
      ],
      defaultValue: "fade",
    },
    {
      name: "imageHeight",
      label: "Hauteur",
      type: "sizing",
    },
    {
      name: "imageRadius",
      label: "Arrondis",
      type: "radius",
    },
  ],
  Badge: [
    {
      name: "badgePosition",
      label: "Position",
      type: "sides",
      units: ["px", "auto"],
    },
    // TODO IMPLEMENT FONYT WEIGHT
  ],
};
